import { SidebarHeader } from '@presentation/Main';

export default function Header() {
  return (
    <SidebarHeader title="Project Files" />
  );
}

export { Header };